module.exports = __webpack_public_path__ + "img/visited-sites.bf0232c5.svg";